module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('form', [_c('website', {
    ref: "website"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n      This is WishList\n      ")]), _vm._v(" "), _c('footerWebsite', {
    ref: "footerWebsite"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f4eaaa4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ecommerce/wishlist.vue
// module id = 2120
// module chunks = 0